import React from "react";
import {
  Pane,
  Dialog,
  Badge,
  Text,
  Strong,
  Button,
  Heading,
  Menu,
  PhoneIcon,
  ChangesIcon,
  majorScale,
} from "evergreen-ui";
import { withRouter } from "react-router-dom";
import EnableReschedule from "./enableReschedule";
import MarkNoSHow from "./markNoShow";
import { getFormattedTime, getFormattedDate, getCurrency } from "../util";
import BookingCheckIn from "./BookingCheckIn";

const BookingDetailsDialog = (props) => {
  const {
    isShown,
    showDialog,
    bookingDetails,
    showConfirmationDialog,
    cancelBooking,
    sendBookingPaymentLink,
    showBookingTransactionsDialog,
    showPayNowDialog,
    showRescheduleDialog,
    printStatement,
    enableReschedule,
    onNoShow,
    bookingCheckIn,
  } = props;

  let {
    sport,
    bookingId,
    bookingType,
    courts,
    slotCount,
    dateBooked,
    startTime,
    endTime,
    customerDetails,
    grossAmount,
    discount,
    paymentMode,
    advance,
    balance,
    showPaymentLink,
    bookingCancelled,
    isPlayoBooking,
    rescheduleEnableText,
    isBnpl,
    checkinData,
    type,
    eventName,
    moreInfo,
  } = bookingDetails;

  const currency = getCurrency();

  return (
    <Dialog
      isShown={isShown}
      title={"Booking Details"}
      onCloseComplete={() => showDialog(false)}
      hasFooter={false}
    >
      {type === 1 && (
        <Pane
          display={"flex"}
          justifyContent={"flex-end"}
          borderBottom={"default"}
          marginBottom={10}
        >
          <Button
            appearance={"minimal"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
            iconBefore={"changes"}
            marginRight={10}
            padding={0}
            onClick={() => showBookingTransactionsDialog(true, bookingId)}
          >
            Transactions
          </Button>
          <Button
            appearance={"minimal"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
            iconBefore={"document-open"}
            marginLeft={10}
            padding={0}
            onClick={() => printStatement(bookingId)}
          >
            Statement
          </Button>
        </Pane>
      )}
      <Pane
        display={"flex"}
        flexDirection={"column"}
        borderBottom={"default"}
        marginBottom={10}
      >
        <Pane
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"space-between"}
          // justifyContent={isPlayoBooking ? "space-between" : "flex-start"}
          marginBottom={10}
          width={"full"}
        >
          <Badge
            color={"#3366FF"}
            display={"flex"}
            flexDirection="row"
            alignItems={"center"}
            height={"20px"}
            maxWidth={"max-content"}
            isSolid
          >
            <Strong color={"white"} alignItems={"center"} size={300}>
              {sport}
            </Strong>
          </Badge>
          {isPlayoBooking ? (
            <Pane
              display={"flex"}
              marginTop={"10px"}
              alignItems="center"
              flexDirection="row"
            >
              {/* <img
                height={"20px"}
                alt='playo-logo'
                width={"20px"}
                src='https://playo-website.gumlet.io/playo-website-v2/logos-icons/Playo+Logo+-+Ball+Boxed.svg'
              /> */}
              <Badge
                background={"#00B562"}
                display="flex"
                alignItems={"center"}
                flexDirection="row"
                isSolid
                height={"20px"}
              >
                Playo Booking
              </Badge>
            </Pane>
          ) : null}
        </Pane>
        <Pane
          display={"flex"}
          justifyContent={"space-between"}
          flexDirection={"column"}
          marginBottom={10}
        >
          <Pane display={"flex"} justifyContent={"space-between"}>
            <Heading size={100}>Booking ID</Heading>
            {type === 1 && <Heading size={100}>Type</Heading>}
          </Pane>
          <Pane display={"flex"} justifyContent={"space-between"}>
            <Strong>{bookingId}</Strong>

            {type === 1 && <Text>{bookingType}</Text>}
          </Pane>
        </Pane>
        <Strong marginBottom={8}>{`${courts} | ${slotCount} slot(s)`}</Strong>
        <Strong marginBottom={10}>
          {`${getFormattedDate(
            dateBooked,
            "YYYY-MM-DD HH:mm:ss",
            "ddd, Do MMM"
          )} |
                    ${getFormattedTime(startTime)} - ${getFormattedTime(
            endTime
          )}`}
        </Strong>

        {type === 0 && (
          <Pane
            display={"flex"}
            justifyContent={"space-between"}
            flexDirection={"column"}
            marginBottom={10}
          >
            <Pane display={"flex"} justifyContent={"space-between"}>
              <Heading size={100}>Event Name</Heading>
              {type === 1 && <Heading size={100}>Type</Heading>}
            </Pane>
            <Pane display={"flex"} justifyContent={"space-between"}>
              <Strong>{eventName}</Strong>

              {type === 1 && <Text>{bookingType}</Text>}
            </Pane>
          </Pane>
        )}
      </Pane>
      <Pane
        display={"flex"}
        flexDirection={"column"}
        borderBottom={"default"}
        marginBottom={10}
      >
        <Pane
          display={"flex"}
          justifyContent={"space-between"}
          flexDirection={"column"}
          marginBottom={10}
        >
          <Pane display={"flex"} justifyContent={"space-between"}>
            <Heading size={100}>Name</Heading>
            <Heading size={100}>Phone Number</Heading>
          </Pane>
          <Pane display={"flex"} justifyContent={"space-between"}>
            <Text>{customerDetails && customerDetails["customerName"]}</Text>
            <Pane
              display={"flex"}
              flexDirection="row"
              justifyContent={"flex-end"}
            >
              <div className={"solid-icon-container"}>
                <PhoneIcon size={8} color="white" />
              </div>
              {customerDetails && (
                <Strong
                  is="a"
                  href={`tel:${customerDetails.customerMobile}`}
                  className={"no-underline"}
                >
                  {customerDetails["customerMobile"]}
                </Strong>
              )}
            </Pane>
          </Pane>
        </Pane>
        <Pane
          display={"flex"}
          justifyContent={"space-between"}
          flexDirection={"column"}
          marginBottom={10}
        >
          <Pane display={"flex"} justifyContent={"space-between"}>
            <Heading size={100}>Email</Heading>
          </Pane>
          <Pane display={"flex"} justifyContent={"space-between"}>
            <Text>{customerDetails && customerDetails["customerEmail"]}</Text>
          </Pane>
        </Pane>
      </Pane>
      {type !== 2 && (
        <Pane
          display={"flex"}
          justifyContent={"space-between"}
          flexDirection={"column"}
          borderBottom={"default"}
          marginBottom={10}
        >
          <Pane
            display={"flex"}
            justifyContent={"space-between"}
            marginBottom={8}
          >
            <Heading size={100}>
              <b>Gross</b>
            </Heading>
            <Text>{`${currency} ${grossAmount}`}</Text>
          </Pane>
          <Pane
            display={"flex"}
            justifyContent={"space-between"}
            marginBottom={8}
          >
            <Heading size={100}>
              <b>Discount</b>
            </Heading>
            <Text>{`${currency} ${discount}`}</Text>
          </Pane>
          <Pane
            display={"flex"}
            justifyContent={"space-between"}
            marginBottom={8}
          >
            <Heading size={100}>
              <b>Advance</b>
            </Heading>
            <Text>{`${currency} ${advance}`}</Text>
          </Pane>
          <Pane
            display={"flex"}
            justifyContent={"space-between"}
            marginBottom={10}
          >
            <Heading size={100}>
              <b>Payment Mode</b>
            </Heading>
            <Text>{paymentMode}</Text>
          </Pane>
        </Pane>
      )}
      {type === 1 && (
        <Pane
          display={"flex"}
          flexDirection={"column"}
          borderBottom={"default"}
          marginBottom={10}
        >
          <Pane
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            marginBottom={10}
          >
            <Strong>Balance</Strong>
            <Pane display={"flex"} alignItems={"center"}>
              <Strong>{`${currency} ${balance}`}</Strong>
              {balance && !bookingCancelled ? (
                <Button
                  marginLeft={10}
                  appearance={"primary"}
                  onClick={() => showPayNowDialog(true)}
                >
                  Pay Now
                </Button>
              ) : (
                <React.Fragment />
              )}
            </Pane>
          </Pane>
          {/* {balance && !bookingCancelled && showPaymentLink ? <Pane
                    display={"flex"}
                    justifyContent={"flex-end"}
                    marginBottom={10}
                >
                    <Button
                        className={"remind-payment-button"}
                        intent={"warning"}
                        width={"100%"}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        onClick={() => sendBookingPaymentLink(bookingId)}
                    >
                        Remind Payment
                    </Button>
                </Pane> : <React.Fragment/>} */}
        </Pane>
      )}
      {type === 1 && (
        <Pane display={"flex"} flexDirection="column">
          {isPlayoBooking && (
            <EnableReschedule
              onReschedule={enableReschedule}
              rescheduleEnableText={rescheduleEnableText}
              bookingId={bookingId}
              startTime={""}
            />
          )}
          {isBnpl && !bookingCancelled && (
            <MarkNoSHow onNoShow={onNoShow} bookingId={bookingId} />
          )}
        </Pane>
      )}
      {isPlayoBooking ? (
        <Pane display={"flex"} alignItems={"center"} justifyContent={"center"}>
          <Text size={100} color={"muted"}>
            <em>Contact Playo to modify Playo bookings</em>
          </Text>
        </Pane>
      ) : (
        <React.Fragment>
          {bookingCancelled ? (
            <Pane
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Text size={100} color={"muted"}>
                <em>Booking is Cancelled</em>
              </Text>
            </Pane>
          ) : (
            type === 1 && (
              <Pane display={"flex"} justifyContent={"space-between"}>
                <Button
                  intent={"success"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  width={"100%"}
                  marginRight={5}
                  onClick={() => showRescheduleDialog(true)}
                >
                  Reschedule
                </Button>
                <Button
                  className={"cancel-button"}
                  intent={"danger"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  width={"100%"}
                  marginLeft={5}
                  onClick={() => {
                    showDialog(false);
                    showConfirmationDialog({
                      status: true,
                      header: "Booking Cancellation",
                      confirmLabel: "Yes",
                      cancelLabel: "No",
                      intent: "danger",
                      information: (
                        <Pane display={"flex"} flexDirection={"column"}>
                          <Pane
                            display={"flex"}
                            flexDirection={"row"}
                            flexBasis={"100%"}
                            justifyContent={"space-between"}
                            marginBottom={10}
                          >
                            <Strong>{dateBooked}</Strong>
                            <Strong>
                              {`${getFormattedTime(
                                startTime
                              )} - ${getFormattedTime(endTime)}`}
                            </Strong>
                          </Pane>
                          <Pane
                            display={"flex"}
                            flexDirection={"row"}
                            flexBasis={"100%"}
                            justifyContent={"space-between"}
                            marginBottom={10}
                          >
                            <Strong>{bookingId}</Strong>
                            <Text>{courts}</Text>
                          </Pane>
                          <Pane
                            display={"flex"}
                            flexDirection={"row"}
                            flexBasis={"100%"}
                            justifyContent={"space-between"}
                          >
                            <Text>
                              {customerDetails &&
                                customerDetails["customerName"]}
                            </Text>
                            <Text>
                              {customerDetails &&
                                customerDetails["customerMobile"]}
                            </Text>
                          </Pane>
                          <Pane
                            width={"100%"}
                            marginTop={"20px"}
                            borderRadius={"5px"}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            background={isPlayoBooking ? "#CCFFE7" : "#FFDAD4"}
                            height={"20px"}
                          >
                            <Pane
                              size="400"
                              color={isPlayoBooking ? "#00331B" : "#410001"}
                            >
                              {isPlayoBooking
                                ? "Playo Booking"
                                : "Club Booking"}
                            </Pane>
                          </Pane>
                        </Pane>
                      ),
                      action: () => cancelBooking(bookingId),
                    });
                  }}
                >
                  Cancel Booking
                </Button>
              </Pane>
            )
          )}
        </React.Fragment>
      )}

      {!bookingCancelled && (
        <Pane
          display="flex"
          justifyContent={""}
          flexDirection={"row"}
          marginTop={10}
        >
          <BookingCheckIn
            bookingId={bookingId}
            bookingCheckIn={bookingCheckIn}
            checkinData={checkinData}
            type={type}
            moreInfo={moreInfo}
            bookingDate={dateBooked}
          />
        </Pane>
      )}
    </Dialog>
  );
};

export default withRouter(BookingDetailsDialog);
